import type { ApiEndpointDefinition } from '../api-endpoint.types';
import type {
  ResolveCameraAlarmHistoryResponse,
  ResolveCreateIncidentResponse,
  ResolveEventsResponse,
  ResolveSiteContactsResponse,
  ResolveSiteEventHistoryResponse,
} from '../../models/entities/resolve-api.model';

/**
 * Resolve OpenAPI v1 paths (prefixed `/api/resolve` for EBM / YARP).
 * Contract-only until Agent UI surfaces consume them.
 */
export const RESOLVE_OPENAPI_ENDPOINTS = {
  resolveSiteContacts: {
    id: 'resolve-site-contacts',
    method: 'GET',
    apiPath: '/api/resolve/sites/:siteId/contacts',
    page: 'events',
    entity: 'resolve-site-contacts',
  } satisfies ApiEndpointDefinition<ResolveSiteContactsResponse>,
  resolveSiteEventHistory: {
    id: 'resolve-site-event-history',
    method: 'GET',
    apiPath: '/api/resolve/sites/:siteId/event-history',
    page: 'events',
    entity: 'resolve-site-event-history',
  } satisfies ApiEndpointDefinition<ResolveSiteEventHistoryResponse>,
  resolveCameraAlarmHistory: {
    id: 'resolve-camera-alarm-history',
    method: 'GET',
    apiPath: '/api/resolve/cameras/:cameraId/alarm-history',
    page: 'events',
    entity: 'resolve-camera-alarm-history',
  } satisfies ApiEndpointDefinition<ResolveCameraAlarmHistoryResponse>,
  resolveCreateIncident: {
    id: 'resolve-create-incident',
    method: 'POST',
    apiPath: '/api/resolve/events/create-incident',
    page: 'events',
    entity: 'resolve-create-incident',
  } satisfies ApiEndpointDefinition<ResolveCreateIncidentResponse>,
  resolveEventsEscalated: {
    id: 'resolve-events-escalated',
    method: 'GET',
    apiPath: '/api/resolve/events/escalated',
    page: 'events',
    entity: 'resolve-events-escalated',
  } satisfies ApiEndpointDefinition<ResolveEventsResponse>,
  resolveEventsInProgress: {
    id: 'resolve-events-in-progress',
    method: 'GET',
    apiPath: '/api/resolve/events/in-progress',
    page: 'events',
    entity: 'resolve-events-in-progress',
  } satisfies ApiEndpointDefinition<ResolveEventsResponse>,
  resolveEventsParked: {
    id: 'resolve-events-parked',
    method: 'GET',
    apiPath: '/api/resolve/events/parked',
    page: 'events',
    entity: 'resolve-events-parked',
  } satisfies ApiEndpointDefinition<ResolveEventsResponse>,
} as const satisfies Record<string, ApiEndpointDefinition>;
